module.exports = __webpack_public_path__ + "img/no-block.709fb7e4.svg";